const ProjectsData = [
  {
    id: 0,
    projectTitle: "MERN Movie App",
    projectDescription:
      "Movie App built on MERN stack which displays trending, popular and top rated movies, along with filtering movies using key word search and genre search. Providing all information about movies like description, IMDB ratings etc.",
    projectsTags: ["ReactJS", "NodeJS", "MongoDB", "CSS"],
    projectGithubLink: "https://github.com/SaranshM/MERN-Movie-App",
    projectLink: "https://mern-movie-app-saransh.netlify.app/",
    projectImage:
      "https://repository-images.githubusercontent.com/446441410/c7274766-29bf-4504-b586-87e2ed058606",
  },
  {
    id: 1,
    projectTitle: "COVID - 19 Tracker",
    projectDescription:
      "Developed a web application which gathers data from around the world using third party APIs and displays key details such as total confirmed, active, death and recovered cases, along with infographics of the data depicting trends over time.",
    projectsTags: ["HTML", "CSS", "JavaScript", "NodeJS", "ChartJS"],
    projectGithubLink: "https://github.com/SaranshM/Covid19Tracker",
    projectLink: "https://covid19tracker.cyclic.app/",
    projectImage:
      "https://repository-images.githubusercontent.com/257967920/22933d67-8aa2-4944-aac4-123bf637acee",
  },
  {
    id: 2,
    projectTitle: "Multiplayer Tic-Tac-Toe Game",
    projectDescription:
      "Developed a real-time multiplayer tic-tac-toe game on HTML, CSS, JavaScript, NodeJS, ExpressJS, Socket.io and      MongoDB.",
    projectsTags: ["HTML", "CSS", "JavaScript", "NodeJS", "Socket.IO"],
    projectGithubLink: "https://github.com/SaranshM/Multiplayer-Tic-Tac-Toe",
    projectLink:
      "https://saranshm.github.io/Multiplayer-Tic-Tac-Toe/public/html/index.html",
    projectImage:
      "https://repository-images.githubusercontent.com/371627798/0c0a769e-52f2-4b6e-935d-1463e7cc4401",
  },
  {
    id: 3,
    projectTitle: "ARCs '20 Promotional Website",
    projectDescription:
      "IEEECS-VIT's flagship event ARCs '20 promotional website providing exceptional digital experience.",
    projectsTags: ["HTML", "CSS", "JavaScript"],
    projectGithubLink:
      "https://github.com/SaranshM/ARCs-2020-Promotional-Website",
    projectLink: "https://saranshm.github.io/ARCs-2020-Promotional-Website/",
    projectImage:
      "https://repository-images.githubusercontent.com/236970902/7cc62edc-8feb-459d-b5ae-f76c35cb94e9",
  },
];

export default ProjectsData;
